<template>
  <info-modal @close-popup="closePopup">
    <template v-slot:title>
      <h3 class="title title--center failure__title">Successful transaction</h3>
    </template>
    <template v-slot:icon>
      <img src="@/assets/icons/Celebration.svg" alt="Success icon" />
    </template>

    <template v-slot:content>
      <div class="success">
        <div class="success__content">
          You have successfully paid with <img class="success-content__badge" :src="CelebrationLogo" alt="logo" />
        </div>

        <div @click="redirectUrl" class="success__c-t-a btn btn__primary btn--lg">
          <button>Ok</button>
        </div>
      </div>
    </template>
  </info-modal>
</template>

<script lang="ts" setup>
import CelebrationLogo from '@/assets/icons/CelebrationLogo.svg'
import InfoModal from '@/components/info-modal/index.vue'
import store from '@/composables/useZeroWidgetStore/methods'

const emit = defineEmits<{
  (e: 'close-popup'): void
}>()
const closePopup = () => {
  return emit('close-popup')
}

const redirectUrl = () => {
  window.location.href = store.state.redirectUrl
}
</script>
